import { getErrorMessage } from '../../../../api/unwrapQuery';
import { useState } from 'react';
import { Formik, Form } from 'formik';
import { Button, Callout, FormField, PasswordInput, TextInput } from '@neshane/blueberry';
import { postApiAdminAuthLogin } from '../../../../generated/apiClient';
import { adminLoginSchema } from '../../../../common/validation';
import { useAuth } from '../../hooks';
import { AuthLayout } from '../AuthLayout';

/**
 * Operator Login Form Component
 * Uses same endpoint as admin login (postApiAdminAuthLogin)
 * HttpOnly cookie auth
 */
function OperatorLoginForm({ onLogin }) {
    const { login } = useAuth();
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleOperatorLogin = async (values, { setSubmitting }) => {
        try {
            setError(null);
            setLoading(true);

            const response = await postApiAdminAuthLogin({
                username: values.username,
                password: values.password,
            });

            const adminData = response.admin || response.data?.admin;
            if ((response.success || adminData) && adminData) {
                if (adminData?.role !== 'operator') {
                    setError('Invalid operator credentials');
                    setLoading(false);
                    setSubmitting(false);
                    return;
                }
                await login(adminData, adminData);
                onLogin(adminData);
            } else {
                setError(response.error || response.message || 'Login failed');
                setLoading(false);
                setSubmitting(false);
            }
        } catch (err) {
            if (process.env.NODE_ENV === 'development') console.error('Operator login error:', err);
            setError(getErrorMessage(err, 'An error occurred during login'));
            setLoading(false);
            setSubmitting(false);
        }
    };

    return (
        <AuthLayout title="ورود اپراتور" subtitle="برای دسترسی به پنل اپراتور، وارد شوید">
            {error && (
                <Callout variant="alert" title={error} iconName="triangle-warning" />
            )}

            <Formik
                initialValues={{ username: '', password: '' }}
                validationSchema={adminLoginSchema}
                onSubmit={handleOperatorLogin}
            >
                {({ errors, touched, values, handleChange, handleBlur, isSubmitting, isValid }) => (
                    <Form>
                        <FormField
                            label="نام کاربری"
                            alertMessage={touched.username ? errors.username : undefined} infoTipContent="نام کاربری را وارد کنید">
                            <TextInput
                                name="username"
                                fit="parent"
                                autoFocus
                                placeholder="نام کاربری"
                                value={values.username}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isInvalid={Boolean(touched.username && errors.username)}
                                isDisabled={loading || isSubmitting}
                            />
                        </FormField>

                        <FormField
                            label="رمز عبور"
                            alertMessage={touched.password ? errors.password : undefined} infoTipContent="رمز عبور را وارد کنید">
                            <PasswordInput
                                name="password"
                                fit="parent"
                                placeholder="رمز عبور"
                                value={values.password}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isDisabled={loading || isSubmitting}
                            />
                        </FormField>

                        <Button
                            type="submit"
                            text={loading || isSubmitting ? 'در حال ورود...' : 'ورود'}
                            variant="primaryBrand"
                            fit="parent"
                            isDisabled={loading || isSubmitting || !isValid}
                            isLoading={loading || isSubmitting}
                        />
                    </Form>
                )}
            </Formik>
        </AuthLayout>
    );
}

export default OperatorLoginForm;
